import React, { Component } from 'react';
import './AlliedHealth.scss'
import { Link } from 'react-router-dom'
import Swiper from 'react-id-swiper'
import 'react-id-swiper/src/styles/css/swiper.css'

class AlliedHealth extends Component {
	componentDidMount() {

	}
	render() {

		const params = {
			pagination: {
			  el: '.swiper-pagination',
			  type: 'bullets',
			  clickable: true
			},
			breakpoints: {
				992: {
				  slidesPerView: 1.25,
				},
			},
			centeredSlides: true,
			slidesPerView: 1.5,
			spaceBetween: 30,
		}
		
		return (
			<div className="allied-health">
				<NewBanner />
				<div className="p-1">
					<Swiper {...params}>
						<div className="slide" style={{ backgroundImage: `url(${require('./435746596.jpg')})`, }}>
							<h3>To achieve the best health outcomes for our patients, we need to work together.</h3>
						</div>
						<div className="slide" style={{ backgroundImage: `url(${require('./695046586.jpg')})`, }}>
							<h3>We want to improve the relationship between doctors and allied health professionals</h3>
						</div>
						<div className="slide" style={{ backgroundImage: `url(${require('./676224040.jpg')})`, }}>
							<h3>Currently, there exists a direct referral system between GPs and medical specialists. This is it.</h3>
						</div>
						<div className="slide" style={{ backgroundImage: `url(${require('./138847457.jpg')})`, }}>
							<h3>The directory has been in publication for over 20 years and is the most trusted source of referral information for GPs in WA. <br /><br />Over 95% of GP clinics use our directory. More than 2000 GPs rely on us.</h3>
						</div>
					</Swiper>
				</div>
			</div>
		);
	}
}



const NewBanner = () => 
	<div className="new-banner">
		<div className="text-center">
			<img src={require('./alliedhealth.svg')} alt="GPbook Specialist Directory MSSRD" height="280"  />
			<div className="options">
				<h1 ><span >Introducing </span>
					The Allied Health Referral Directory (WA)
				</h1>
				<Link to="/features" className="btn secondary">Apply to get listed in 2019</Link>
				
			</div>

		</div>
	</div>




export default AlliedHealth;


// WEBPACK FOOTER //
// ./src/Containers/AlliedHealth/AlliedHealth.js